import Phaser from 'phaser';
import { Palette } from '@core/config/constants';

export interface OptionButtonOptions {
  x: number;
  y: number;
  width: number;
  label: string;
  onSelect: () => void;
}

const HEIGHT = 70;
const CORNER_RADIUS = 16;
const COLOR_DEFAULT = Palette.secondary;
const COLOR_CORRECT = 0x2ecc71;
const COLOR_WRONG = 0xe74c3c;

/**
 * Boton de respuesta para la trivia. Encapsula fondo, texto y estados visuales
 * (normal, correcto, incorrecto, deshabilitado) para no repetir codigo en la escena.
 */
export class OptionButton extends Phaser.GameObjects.Container {
  private readonly background: Phaser.GameObjects.Graphics;
  private readonly buttonWidth: number;

  public constructor(scene: Phaser.Scene, options: OptionButtonOptions) {
    super(scene, options.x, options.y);
    this.buttonWidth = options.width;

    this.background = scene.add.graphics();
    this.paint(COLOR_DEFAULT);

    const label = scene.add
      .text(0, 0, options.label, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '26px',
        color: Palette.textLight,
        align: 'center',
        wordWrap: { width: options.width - 40 },
      })
      .setOrigin(0.5);

    this.add([this.background, label]);
    this.setSize(options.width, HEIGHT);
    this.setInteractive({ useHandCursor: true });
    this.once(Phaser.Input.Events.POINTER_UP, options.onSelect);

    scene.add.existing(this);
  }

  public markCorrect(): void {
    this.paint(COLOR_CORRECT);
  }

  public markWrong(): void {
    this.paint(COLOR_WRONG);
  }

  public disable(): void {
    this.disableInteractive();
  }

  private paint(color: number): void {
    this.background.clear();
    this.background.fillStyle(color, 1);
    this.background.fillRoundedRect(-this.buttonWidth / 2, -HEIGHT / 2, this.buttonWidth, HEIGHT, CORNER_RADIUS);
  }
}
